export default class ActiveMediaNotSetError extends Error {}
